import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

/*
 * THE SCHEDULE'S TIMING (organiser, 1 Nov 2026) — a competition's and a
 * federation's. Each resolves the endpoint's answer `{timing, custom,
 * ageCategories, boutTypes, performanceTypes, …}`, or null on failure (the
 * error already shown).
 */

const failed = dispatch => error => {
    dispatch(errorRequestHandler(error));

    return null;
};

const call = (dispatch, path, id, data = null) =>
    axios(apiRequestOptions(path, data, { params: { id } }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => transformHttpResponse(error.response))
        .catch(failed(dispatch));

export const fetchScheduleTiming = competitionId => dispatch => call(dispatch, apiPath.SCHEDULE.TIMING_GET, competitionId);

/** `timing` — the values to keep; null — «Скинути до типових». */
export const saveScheduleTiming = (competitionId, timing) => dispatch =>
    call(dispatch, apiPath.SCHEDULE.TIMING_PUT, competitionId, { timing });

export const fetchDisciplineTiming = disciplineId => dispatch => call(dispatch, apiPath.DISCIPLINES.TIMING_GET, disciplineId);

/** `timing` — the values to keep; null — the factory's. */
export const saveDisciplineTiming = (disciplineId, timing) => dispatch =>
    call(dispatch, apiPath.DISCIPLINES.TIMING_PUT, disciplineId, { timing });
